import { Retriever, IState } from "../../../../../common";
import { SportModel } from "../../../model";
import { LiveStreamingBaseRetriever } from "..";
import { liveStreamingQueryFactory } from "../../../queries";

export class LiveStreamingRetriever extends Retriever<SportModel> {

    private readonly baseRetriever: LiveStreamingBaseRetriever;
    private readonly queryFactory: liveStreamingQueryFactory;

    constructor(baseRetriever: LiveStreamingBaseRetriever, liveStreamingQueryFactory: liveStreamingQueryFactory) {
        super();
        this.baseRetriever = baseRetriever;
        this.queryFactory = liveStreamingQueryFactory;
    }

    async activate(state: IState<SportModel>) {
        this.baseRetriever.activate();
        await this.baseRetriever.refresh(state, this.queryFactory);
    }

    deactivate() {
        this.baseRetriever.deactivate();
    }
}